export default {
    //RecordsList
    your_records: 'Els teus enregistraments',
    loading_records: 'Carregant enregistraments...',
    project_name: 'Nom del Curs',
    class_name: 'Nom de la Classe',
    participants: 'Participants',
    total_size: 'Grandària total',

}